import {
    About,
    ActionPage,
    ActionsListingPage,
    DataLibraryPage,
    GdprPage,
    HelpPage,
    InterpretationListingPage,
    InterpretationPage,
    Landing,
    NlSearch,
    OperatorInvocationListingPage,
    OperatorInvocationPage,
    SettingsPage,
    SiteMap,
    SqlSearchPage,
    TriggerActionPage,
} from "#pages";
import React from "react";

type RouteDef = {
    path: string;
    label: string;
    routeEnabled: boolean;
    component: React.ComponentType;
    showOnSiteMap: boolean;
    exact?: boolean;
};

enum RouteKeys {
    root = "root",
    nlSearch = "nlSearch",
    sqlSearch = "sqlSearch",
    settings = "settings",
    about = "about",
    sitemap = "sitemap",
    gdpr = "gdpr",
    help = "help",
    action = "action",
    dataShoppingCart = "dataLibrary",
    actions = "actions",
    operatorInvocation = "operatorInvocation",
    operatorInvocations = "operatorInvocations",
    interpretations = "interpretations",
    interpretation = "interpretation",
    triggerAction = "triggerAction",
}

export const Routes: Record<RouteKeys, RouteDef> = {
    root: {
        path: "/odd3/",
        label: "Home",
        routeEnabled: true,
        showOnSiteMap: true,
        component: Landing,
        exact: true,
    },
    nlSearch: {
        path: "/odd3/nlsearch",
        label: "Natural Language Search",
        routeEnabled: true,
        showOnSiteMap: true,
        component: NlSearch,
    },
    sqlSearch: {
        path: "/odd3/sql",
        label: "Structured Query input",
        routeEnabled: true,
        showOnSiteMap: true,
        component: SqlSearchPage,
    },
    settings: {
        path: "/odd3/settings",
        label: "Settings",
        routeEnabled: true,
        showOnSiteMap: true,
        component: SettingsPage,
    },
    about: {
        path: "/odd3/about",
        label: "About",
        routeEnabled: true,
        showOnSiteMap: true,
        component: About,
    },
    sitemap: {
        path: "/odd3/sitemap",
        label: "Site Map",
        routeEnabled: true,
        showOnSiteMap: true,
        component: SiteMap,
    },
    gdpr: {
        path: "/odd3/gdpr",
        label: "GDPR",
        routeEnabled: true,
        showOnSiteMap: true,
        component: GdprPage,
    },
    help: {
        path: "/help",
        label: "Help",
        routeEnabled: true,
        showOnSiteMap: true,
        component: HelpPage,
    },
    triggerAction: {
        path: "/odd3/search",
        label: "Trigger action",
        routeEnabled: true,
        showOnSiteMap: false,
        component: TriggerActionPage,
    },
    action: {
        path: "/odd3/action/:id",
        label: "Search Results",
        routeEnabled: true,
        showOnSiteMap: false,
        component: ActionPage,
    },
    dataLibrary: {
        path: "/odd3/cart",
        label: "Data Library",
        routeEnabled: true,
        showOnSiteMap: true,
        component: DataLibraryPage,
    },
    actions: {
        path: "/odd3/actions",
        label: "Actions Listing",
        routeEnabled: true,
        showOnSiteMap: true,
        component: ActionsListingPage,
    },
    operatorInvocation: {
        path: "/odd3/operatorInvocation/:id",
        label: "Operator Invocation",
        routeEnabled: true,
        showOnSiteMap: false,
        component: OperatorInvocationPage,
    },
    operatorInvocations: {
        path: "/odd3/operatorInvocations",
        label: "Operator Invocations",
        routeEnabled: true,
        showOnSiteMap: true,
        component: OperatorInvocationListingPage,
    },
    interpretations: {
        path: "/odd3/interpretations",
        label: "Interpretations",
        routeEnabled: true,
        showOnSiteMap: true,
        component: InterpretationListingPage,
    },
    interpretation: {
        path: "/odd3/interpretation/:id",
        label: "Interpretation",
        routeEnabled: true,
        showOnSiteMap: false,
        component: InterpretationPage,
    },
};

export default Routes;
